import { useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'
import { getVerticalMappingJSON } from '@pepper/utils/src/api/utils/utils'

import { useShowMessage } from '../providers'

type ReturnType = {
  data: { response: IVerticalMapping } | null | undefined
  isLoading: boolean
  isFetching: boolean
  isSuccess: boolean
  error: Error | null
  refetch: () => Promise<any | undefined>
}

export const useVerticalMappingJson = (): ReturnType => {
  const showMessage = useShowMessage()

  const handleApiRequest = async () => {
    const {
      status,
      data: _data,
      error: _error
    } = await getVerticalMappingJSON()
    return _data
  }

  const { isLoading, isFetching, isSuccess, isError, data, error, refetch } =
    useQuery<{ response: IVerticalMapping } | null, Error>({
      queryKey: ['vertical-mapping'],
      queryFn: handleApiRequest
    })

  useEffect(() => {
    if (isError) {
      showMessage({ type: 'error', message: error?.message })
    }
  }, [isError, error, showMessage])

  return { data, isLoading, isSuccess, isFetching, error, refetch }
}
